import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  Container as SecondaryContainer,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { SeriesShortLabelLink } from "scmp-app/components/content/content-series-short-label/styles";

export const StyledContentItemHomeSecondary = styled(ContentItemHomeSecondaryV2)`
  ${theme.breakpoints.only("mobile")} {
    :not(:first-of-type) {
      margin-block-start: 12px;
      padding-block-start: 20px;
      border-block-start: 1px solid #000000;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 calc(100% - 20px);

    :first-of-type {
      flex: 1 1 100%;

      margin-inline-end: 20px;
      padding-inline-end: 20px;
      border-inline-end: 1px solid #dfdfdf;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
  }

  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
  }

  ${SeriesShortLabelLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }

  ${SecondaryContainer} {
    grid-template-columns: 1fr 0fr;
    column-gap: 0;
  }
`;
